export default "__VITE_ASSET__2745417a__"